import { render, staticRenderFns } from "./MaterialCodeEquivalence.vue?vue&type=template&id=6061e7a8&scoped=true&"
import script from "./MaterialCodeEquivalence.vue?vue&type=script&lang=js&"
export * from "./MaterialCodeEquivalence.vue?vue&type=script&lang=js&"
import style0 from "./MaterialCodeEquivalence.vue?vue&type=style&index=0&id=6061e7a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6061e7a8",
  null
  
)

export default component.exports